var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('messages-list',{staticClass:"root-doctor-messages",attrs:{"chat-list":_vm.doctorChatList}})}
var staticRenderFns = []

export { render, staticRenderFns }